
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vrgzu_17yy9_145",
  "recovery": "awsui_recovery_vrgzu_17yy9_180"
};
  